import React from 'react';

const No = ({ className }) => {
    return (
        <svg
            className={className}
            width={200}
            height={117}
            viewBox="0 0 200 117"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            //{...props}
        >
            <g clipPath="url(#clip0_46_1508)">
            <rect width={200} height={117} rx={6} fill="#F4F0EC" />
            <path
                d="M29 19C29 17.3431 30.3431 16 32 16H58C59.6569 16 61 17.3431 61 19V40C61 41.6569 59.6569 43 58 43H32C30.3431 43 29 41.6569 29 40V19Z"
                fill="#404040"
            />
            <path d="M35.9782 24.5H61H35.9782Z" fill="#404040" />
            <path
                d="M34 38H47"
                stroke="white"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M55 38H56"
                stroke="#767676"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M40.0224 26.5332L37.3762 29.519C36.5047 30.5023 37.2443 32 38.6015 32H51.3993C52.6273 32 53.3966 30.7455 52.7862 29.7382L49.7692 24.7599C49.2266 23.8647 47.9154 23.7355 47.189 24.5056L45.1387 26.6797C44.5732 27.2794 43.61 27.3559 42.9466 26.8538L42.2467 26.3241C41.5685 25.8107 40.5804 25.9035 40.0224 26.5332Z"
                fill="#818181"
            />
            <path
                d="M41 24C42.1046 24 43 23.1046 43 22C43 20.8954 42.1046 20 41 20C39.8954 20 39 20.8954 39 22C39 23.1046 39.8954 24 41 24Z"
                fill="#E66819"
            />
            <path
                d="M29 79C29 77.3431 30.3431 76 32 76H58C59.6569 76 61 77.3431 61 79V100C61 101.657 59.6569 103 58 103H32C30.3431 103 29 101.657 29 100V79Z"
                fill="#404040"
            />
            <path d="M35.9782 84.5H61H35.9782Z" fill="#404040" />
            <path
                d="M34 98H47"
                stroke="white"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M55 98H56"
                stroke="#767676"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M40.0224 86.5332L37.3762 89.519C36.5047 90.5023 37.2443 92 38.6015 92H51.3993C52.6273 92 53.3966 90.7455 52.7862 89.7382L49.7692 84.7599C49.2266 83.8647 47.9154 83.7355 47.189 84.5056L45.1387 86.6797C44.5732 87.2794 43.61 87.3559 42.9466 86.8538L42.2467 86.3241C41.5685 85.8107 40.5804 85.9035 40.0224 86.5332Z"
                fill="#818181"
            />
            <path
                d="M41 84C42.1046 84 43 83.1046 43 82C43 80.8954 42.1046 80 41 80C39.8954 80 39 80.8954 39 82C39 83.1046 39.8954 84 41 84Z"
                fill="#E66819"
            />
            <path
                d="M29 49C29 47.3431 30.3431 46 32 46H58C59.6569 46 61 47.3431 61 49V70C61 71.6569 59.6569 73 58 73H32C30.3431 73 29 71.6569 29 70V49Z"
                fill="#404040"
            />
            <path d="M35.9782 54.5H61H35.9782Z" fill="#404040" />
            <path
                d="M34 68H47"
                stroke="white"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M55 68H56"
                stroke="#767676"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M40.0224 56.5332L37.3762 59.519C36.5047 60.5023 37.2443 62 38.6015 62H51.3993C52.6273 62 53.3966 60.7455 52.7862 59.7382L49.7692 54.7599C49.2266 53.8647 47.9154 53.7355 47.189 54.5056L45.1387 56.6797C44.5732 57.2794 43.61 57.3559 42.9466 56.8538L42.2467 56.3241C41.5685 55.8107 40.5804 55.9035 40.0224 56.5332Z"
                fill="#818181"
            />
            <path
                d="M41 54C42.1046 54 43 53.1046 43 52C43 50.8954 42.1046 50 41 50C39.8954 50 39 50.8954 39 52C39 53.1046 39.8954 54 41 54Z"
                fill="#E66819"
            />
            <path
                d="M29 109C29 107.343 30.3431 106 32 106H58C59.6569 106 61 107.343 61 109V130C61 131.657 59.6569 133 58 133H32C30.3431 133 29 131.657 29 130V109Z"
                fill="#404040"
            />
            <path d="M35.9782 114.5H61H35.9782Z" fill="#404040" />
            <path
                d="M40.0224 116.533L37.3762 119.519C36.5047 120.502 37.2443 122 38.6015 122H51.3993C52.6273 122 53.3966 120.745 52.7862 119.738L49.7692 114.76C49.2266 113.865 47.9154 113.735 47.189 114.506L45.1387 116.68C44.5732 117.279 43.61 117.356 42.9466 116.854L42.2467 116.324C41.5685 115.811 40.5804 115.904 40.0224 116.533Z"
                fill="#818181"
            />
            <path
                d="M41 114C42.1046 114 43 113.105 43 112C43 110.895 42.1046 110 41 110C39.8954 110 39 110.895 39 112C39 113.105 39.8954 114 41 114Z"
                fill="#E66819"
            />
            <path
                d="M65 19C65 17.3431 66.3431 16 68 16H94C95.6569 16 97 17.3431 97 19V40C97 41.6569 95.6569 43 94 43H68C66.3431 43 65 41.6569 65 40V19Z"
                fill="#404040"
            />
            <path d="M71.9782 24.5H97H71.9782Z" fill="#404040" />
            <path
                d="M70 38H83"
                stroke="white"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M91 38H92"
                stroke="#767676"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M76.0224 26.5332L73.3762 29.519C72.5047 30.5023 73.2443 32 74.6015 32H87.3993C88.6273 32 89.3966 30.7455 88.7862 29.7382L85.7692 24.7599C85.2266 23.8647 83.9154 23.7355 83.189 24.5056L81.1387 26.6797C80.5732 27.2794 79.61 27.3559 78.9466 26.8538L78.2467 26.3241C77.5685 25.8107 76.5804 25.9035 76.0224 26.5332Z"
                fill="#818181"
            />
            <path
                d="M77 24C78.1046 24 79 23.1046 79 22C79 20.8954 78.1046 20 77 20C75.8954 20 75 20.8954 75 22C75 23.1046 75.8954 24 77 24Z"
                fill="#E66819"
            />
            <path
                d="M65 79C65 77.3431 66.3431 76 68 76H94C95.6569 76 97 77.3431 97 79V100C97 101.657 95.6569 103 94 103H68C66.3431 103 65 101.657 65 100V79Z"
                fill="#404040"
            />
            <path d="M71.9782 84.5H97H71.9782Z" fill="#404040" />
            <path
                d="M70 98H83"
                stroke="white"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M91 98H92"
                stroke="#767676"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M76.0224 86.5332L73.3762 89.519C72.5047 90.5023 73.2443 92 74.6015 92H87.3993C88.6273 92 89.3966 90.7455 88.7862 89.7382L85.7692 84.7599C85.2266 83.8647 83.9154 83.7355 83.189 84.5056L81.1387 86.6797C80.5732 87.2794 79.61 87.3559 78.9466 86.8538L78.2467 86.3241C77.5685 85.8107 76.5804 85.9035 76.0224 86.5332Z"
                fill="#818181"
            />
            <path
                d="M77 84C78.1046 84 79 83.1046 79 82C79 80.8954 78.1046 80 77 80C75.8954 80 75 80.8954 75 82C75 83.1046 75.8954 84 77 84Z"
                fill="#E66819"
            />
            <path
                d="M65 49C65 47.3431 66.3431 46 68 46H94C95.6569 46 97 47.3431 97 49V70C97 71.6569 95.6569 73 94 73H68C66.3431 73 65 71.6569 65 70V49Z"
                fill="#404040"
            />
            <path d="M71.9782 54.5H97H71.9782Z" fill="#404040" />
            <path
                d="M70 68H83"
                stroke="white"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M91 68H92"
                stroke="#767676"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M76.0224 56.5332L73.3762 59.519C72.5047 60.5023 73.2443 62 74.6015 62H87.3993C88.6273 62 89.3966 60.7455 88.7862 59.7382L85.7692 54.7599C85.2266 53.8647 83.9154 53.7355 83.189 54.5056L81.1387 56.6797C80.5732 57.2794 79.61 57.3559 78.9466 56.8538L78.2467 56.3241C77.5685 55.8107 76.5804 55.9035 76.0224 56.5332Z"
                fill="#818181"
            />
            <path
                d="M77 54C78.1046 54 79 53.1046 79 52C79 50.8954 78.1046 50 77 50C75.8954 50 75 50.8954 75 52C75 53.1046 75.8954 54 77 54Z"
                fill="#E66819"
            />
            <path
                d="M65 109C65 107.343 66.3431 106 68 106H94C95.6569 106 97 107.343 97 109V130C97 131.657 95.6569 133 94 133H68C66.3431 133 65 131.657 65 130V109Z"
                fill="#404040"
            />
            <path d="M71.9782 114.5H97H71.9782Z" fill="#404040" />
            <path
                d="M76.0224 116.533L73.3762 119.519C72.5047 120.502 73.2443 122 74.6015 122H87.3993C88.6273 122 89.3966 120.745 88.7862 119.738L85.7692 114.76C85.2266 113.865 83.9154 113.735 83.189 114.506L81.1387 116.68C80.5732 117.279 79.61 117.356 78.9466 116.854L78.2467 116.324C77.5685 115.811 76.5804 115.904 76.0224 116.533Z"
                fill="#818181"
            />
            <path
                d="M77 114C78.1046 114 79 113.105 79 112C79 110.895 78.1046 110 77 110C75.8954 110 75 110.895 75 112C75 113.105 75.8954 114 77 114Z"
                fill="#E66819"
            />
            <path
                d="M139 19C139 17.3431 140.343 16 142 16H168C169.657 16 171 17.3431 171 19V40C171 41.6569 169.657 43 168 43H142C140.343 43 139 41.6569 139 40V19Z"
                fill="#404040"
            />
            <path d="M145.978 24.5H171H145.978Z" fill="#404040" />
            <path
                d="M144 38H157"
                stroke="white"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M165 38H166"
                stroke="#767676"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M150.022 26.5332L147.376 29.519C146.505 30.5023 147.244 32 148.601 32H161.399C162.627 32 163.397 30.7455 162.786 29.7382L159.769 24.7599C159.227 23.8647 157.915 23.7355 157.189 24.5056L155.139 26.6797C154.573 27.2794 153.61 27.3559 152.947 26.8538L152.247 26.3241C151.568 25.8107 150.58 25.9035 150.022 26.5332Z"
                fill="#818181"
            />
            <path
                d="M151 24C152.105 24 153 23.1046 153 22C153 20.8954 152.105 20 151 20C149.895 20 149 20.8954 149 22C149 23.1046 149.895 24 151 24Z"
                fill="#E66819"
            />
            <path
                d="M139 79C139 77.3431 140.343 76 142 76H168C169.657 76 171 77.3431 171 79V100C171 101.657 169.657 103 168 103H142C140.343 103 139 101.657 139 100V79Z"
                fill="#404040"
            />
            <path d="M145.978 84.5H171H145.978Z" fill="#404040" />
            <path
                d="M144 98H157"
                stroke="white"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M165 98H166"
                stroke="#767676"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M150.022 86.5332L147.376 89.519C146.505 90.5023 147.244 92 148.601 92H161.399C162.627 92 163.397 90.7455 162.786 89.7382L159.769 84.7599C159.227 83.8647 157.915 83.7355 157.189 84.5056L155.139 86.6797C154.573 87.2794 153.61 87.3559 152.947 86.8538L152.247 86.3241C151.568 85.8107 150.58 85.9035 150.022 86.5332Z"
                fill="#818181"
            />
            <path
                d="M151 84C152.105 84 153 83.1046 153 82C153 80.8954 152.105 80 151 80C149.895 80 149 80.8954 149 82C149 83.1046 149.895 84 151 84Z"
                fill="#E66819"
            />
            <path
                d="M139 49C139 47.3431 140.343 46 142 46H168C169.657 46 171 47.3431 171 49V70C171 71.6569 169.657 73 168 73H142C140.343 73 139 71.6569 139 70V49Z"
                fill="#404040"
            />
            <path d="M145.978 54.5H171H145.978Z" fill="#404040" />
            <path
                d="M144 68H157"
                stroke="white"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M165 68H166"
                stroke="#767676"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M150.022 56.5332L147.376 59.519C146.505 60.5023 147.244 62 148.601 62H161.399C162.627 62 163.397 60.7455 162.786 59.7382L159.769 54.7599C159.227 53.8647 157.915 53.7355 157.189 54.5056L155.139 56.6797C154.573 57.2794 153.61 57.3559 152.947 56.8538L152.247 56.3241C151.568 55.8107 150.58 55.9035 150.022 56.5332Z"
                fill="#818181"
            />
            <path
                d="M151 54C152.105 54 153 53.1046 153 52C153 50.8954 152.105 50 151 50C149.895 50 149 50.8954 149 52C149 53.1046 149.895 54 151 54Z"
                fill="#E66819"
            />
            <path
                d="M139 109C139 107.343 140.343 106 142 106H168C169.657 106 171 107.343 171 109V130C171 131.657 169.657 133 168 133H142C140.343 133 139 131.657 139 130V109Z"
                fill="#404040"
            />
            <path d="M145.978 114.5H171H145.978Z" fill="#404040" />
            <path
                d="M150.022 116.533L147.376 119.519C146.505 120.502 147.244 122 148.601 122H161.399C162.627 122 163.397 120.745 162.786 119.738L159.769 114.76C159.227 113.865 157.915 113.735 157.189 114.506L155.139 116.68C154.573 117.279 153.61 117.356 152.947 116.854L152.247 116.324C151.568 115.811 150.58 115.904 150.022 116.533Z"
                fill="#818181"
            />
            <path
                d="M151 114C152.105 114 153 113.105 153 112C153 110.895 152.105 110 151 110C149.895 110 149 110.895 149 112C149 113.105 149.895 114 151 114Z"
                fill="#E66819"
            />
            <path
                d="M102 19C102 17.3431 103.343 16 105 16H131C132.657 16 134 17.3431 134 19V40C134 41.6569 132.657 43 131 43H105C103.343 43 102 41.6569 102 40V19Z"
                fill="#404040"
            />
            <path d="M108.978 24.5H134H108.978Z" fill="#404040" />
            <path
                d="M107 38H120"
                stroke="white"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M128 38H129"
                stroke="#767676"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M113.022 26.5332L110.376 29.519C109.505 30.5023 110.244 32 111.601 32H124.399C125.627 32 126.397 30.7455 125.786 29.7382L122.769 24.7599C122.227 23.8647 120.915 23.7355 120.189 24.5056L118.139 26.6797C117.573 27.2794 116.61 27.3559 115.947 26.8538L115.247 26.3241C114.568 25.8107 113.58 25.9035 113.022 26.5332Z"
                fill="#818181"
            />
            <path
                d="M114 24C115.105 24 116 23.1046 116 22C116 20.8954 115.105 20 114 20C112.895 20 112 20.8954 112 22C112 23.1046 112.895 24 114 24Z"
                fill="#E66819"
            />
            <path
                d="M102 79C102 77.3431 103.343 76 105 76H131C132.657 76 134 77.3431 134 79V100C134 101.657 132.657 103 131 103H105C103.343 103 102 101.657 102 100V79Z"
                fill="#404040"
            />
            <path d="M108.978 84.5H134H108.978Z" fill="#404040" />
            <path
                d="M107 98H120"
                stroke="white"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M128 98H129"
                stroke="#767676"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M113.022 86.5332L110.376 89.519C109.505 90.5023 110.244 92 111.601 92H124.399C125.627 92 126.397 90.7455 125.786 89.7382L122.769 84.7599C122.227 83.8647 120.915 83.7355 120.189 84.5056L118.139 86.6797C117.573 87.2794 116.61 87.3559 115.947 86.8538L115.247 86.3241C114.568 85.8107 113.58 85.9035 113.022 86.5332Z"
                fill="#818181"
            />
            <path
                d="M114 84C115.105 84 116 83.1046 116 82C116 80.8954 115.105 80 114 80C112.895 80 112 80.8954 112 82C112 83.1046 112.895 84 114 84Z"
                fill="#E66819"
            />
            <path
                d="M102 49C102 47.3431 103.343 46 105 46H131C132.657 46 134 47.3431 134 49V70C134 71.6569 132.657 73 131 73H105C103.343 73 102 71.6569 102 70V49Z"
                fill="#404040"
            />
            <path d="M108.978 54.5H134H108.978Z" fill="#404040" />
            <path
                d="M107 68H120"
                stroke="white"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M128 68H129"
                stroke="#767676"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M113.022 56.5332L110.376 59.519C109.505 60.5023 110.244 62 111.601 62H124.399C125.627 62 126.397 60.7455 125.786 59.7382L122.769 54.7599C122.227 53.8647 120.915 53.7355 120.189 54.5056L118.139 56.6797C117.573 57.2794 116.61 57.3559 115.947 56.8538L115.247 56.3241C114.568 55.8107 113.58 55.9035 113.022 56.5332Z"
                fill="#818181"
            />
            <path
                d="M114 54C115.105 54 116 53.1046 116 52C116 50.8954 115.105 50 114 50C112.895 50 112 50.8954 112 52C112 53.1046 112.895 54 114 54Z"
                fill="#E66819"
            />
            <path
                d="M102 109C102 107.343 103.343 106 105 106H131C132.657 106 134 107.343 134 109V130C134 131.657 132.657 133 131 133H105C103.343 133 102 131.657 102 130V109Z"
                fill="#404040"
            />
            <path d="M108.978 114.5H134H108.978Z" fill="#404040" />
            <path
                d="M113.022 116.533L110.376 119.519C109.505 120.502 110.244 122 111.601 122H124.399C125.627 122 126.397 120.745 125.786 119.738L122.769 114.76C122.227 113.865 120.915 113.735 120.189 114.506L118.139 116.68C117.573 117.279 116.61 117.356 115.947 116.854L115.247 116.324C114.568 115.811 113.58 115.904 113.022 116.533Z"
                fill="#818181"
            />
            <path
                d="M114 114C115.105 114 116 113.105 116 112C116 110.895 115.105 110 114 110C112.895 110 112 110.895 112 112C112 113.105 112.895 114 114 114Z"
                fill="#E66819"
            />
            </g>
            <defs>
            <clipPath id="clip0_46_1508">
                <rect width={200} height={117} fill="white" />
            </clipPath>
            </defs>
        </svg>
    )
}

export default No;